import { SEND_OCA_LINK } from './sendOcaLink';

export const sendCreditApplicationApi = {
  sendOcaLink: SEND_OCA_LINK,
};

export { ApiContainer } from './ApiContainer';
